import React from "react";

// A template thumbnail, drawn from the template's own configuration JSON.
//
// report_templates stores no thumbnail image. What it does store is
// configuration.visualTemplate.pages[].blocks[], each with an absolute position and
// size, so a wireframe can be rendered with no scan data at all — only the block
// contents need data. That is why this is a render rather than an <img>.
//
// Templates with no stored layout (the predefined ones, which are code rather than
// config) fall back to a generic page shape instead of an empty box.

const PALETTE = ["#94303d", "#d1495b", "#d99423"];

const TemplateThumb = ({ template }) => {
  const pages = template?.configuration?.visualTemplate?.pages || [];
  const first = pages[0];
  const blocks = (first?.blocks || []).slice(0, 12);

  if (!blocks.length) {
    return (
      <div className="v2-thumb">
        <div className="v2-thumb-band" />
        <span className="v2-thumb-line" style={{ width: "70%" }} />
        <span className="v2-thumb-line" style={{ width: "100%" }} />
        <span className="v2-thumb-line" style={{ width: "84%" }} />
        <div className="v2-thumb-bars">
          {PALETTE.map((c, i) => (
            <span key={c} style={{ background: c, height: `${100 - i * 30}%` }} />
          ))}
        </div>
      </div>
    );
  }

  // Normalise to the widest block so the wireframe fills the tile regardless of the
  // page size the template was authored at.
  const maxX = Math.max(...blocks.map((b) => (b.position?.x || 0) + (b.size?.width || 100)), 1);
  const maxY = Math.max(...blocks.map((b) => (b.position?.y || 0) + (b.size?.height || 40)), 1);

  return (
    <div className="v2-thumb v2-thumb--wire" aria-hidden="true">
      {blocks.map((b, i) => (
        <span
          key={i}
          className="v2-thumb-block"
          style={{
            left: `${((b.position?.x || 0) / maxX) * 100}%`,
            top: `${((b.position?.y || 0) / maxY) * 100}%`,
            width: `${((b.size?.width || 100) / maxX) * 100}%`,
            height: `${((b.size?.height || 40) / maxY) * 100}%`,
          }}
        />
      ))}
    </div>
  );
};

export default TemplateThumb;
